import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaArrowRight, FaCheck } from "react-icons/fa";
import { motion } from "framer-motion";
import "./herosec.css";

const services = [
  "End-to-End GCC Setup",
  "Regulatory & Compliance Support",
  "Finance & Treasury Management",
  "Talent Acquisition & HR Solutions",
  "Executive Relocation Services",
  "Dedicated Relationship Management",
];

const Herosec = () => {
  return (
    <div>
      <section className="hero-section">
        <Container>
          <Row className="align-items-center gy-5">
            {/* Left */}

            <Col lg={6}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
              >
                <span className="hero-badge">
                  YOUR GATEWAY TO GIFT CITY SUCCESS
                </span>

                <h1 className="hero-title">
                  Build, Scale & Operate
                  <span>Your GCC in GIFT City</span>
                </h1>

                <p className="hero-text">
                  India's premier international financial hub is rapidly
                  becoming the preferred destination for Global Capability
                  Centres (GCCs), fintech companies, innovation hubs and
                  multinational service centres.
                </p>

                <p className="hero-text small">
                  From company formation and regulatory approvals to talent
                  acquisition and operational support, we become your strategic
                  partner throughout the journey.
                </p>

                <div className="hero-buttons">
                  <Button className="btn-orange">Schedule Consultation</Button>

                  <Button className="btn-outline-dark">
                    Explore GCC Directory
                    <FaArrowRight />
                  </Button>
                </div>
              </motion.div>

              <motion.div
                className="service-section"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
              >
                <h6>SERVICES INCLUDE</h6>

                <div className="service-grid">
                  {services.map((item, i) => (
                    <motion.div
                      key={i}
                      whileHover={{
                        scale: 1.05,
                        y: -4,
                      }}
                      className="service-pill"
                    >
                      <FaCheck />

                      {item}
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            </Col>

            {/* Right */}

            <Col lg={6}>
              <motion.div
                className="hero-image-wrapper"
                initial={{
                  opacity: 0,
                  scale: 0.8,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                transition={{
                  duration: 0.8,
                }}
              >
                <img
                  src="./images/hero_bg.png"
                  alt="Gift City"
                  className="hero-image"
                />

                <motion.div
                  animate={{
                    y: [0, -10, 0],
                  }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                  }}
                  className="floating-card"
                >
                  <h2>1,600+</h2>

                  <p>GCCs Active in India</p>
                </motion.div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Herosec;
